/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from "@reduxjs/toolkit";
import server from "api/server";

export const getSessionsAction = createAsyncThunk(
  "getGuestUserSessions",

  async (payload: any) => {
    try {
      const { data } = await server.adminDashboard.getSessionLength(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const getSessionLengthAction = createAsyncThunk(
  "getSubscribedUserSessions",

  async (payload: any) => {
    try {
      const { data } = await server.adminDashboard.getSessionLength(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const getRevenueAction = createAsyncThunk(
  "getRevenueAction",

  async (payload: any) => {
    try {
      const { data } = await server.adminDashboard.getRevenueData(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const getSubscribedUserReportsAction = createAsyncThunk(
  "getSubscribedUserReports",

  async (payload: any) => {
    try {
      const { data } = await server.adminDashboard.getSubscribedUserReports(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const getDashboardSessionsAction = createAsyncThunk(
  "getMonthlyData",

  async (payload: any) => {
    try {
      const { data } = await server.adminDashboard.getDashboardSessionsData(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const getPurchasesAction = createAsyncThunk(
  "getMonthlyData",

  async (payload: any) => {
    try {
      const { data } = await server.adminDashboard.getPurchasesData(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const getTransactionsAction = createAsyncThunk(
  "getTransactionData",

  async (payload: any) => {
    try {
      const { data } = await server.adminDashboard.getTransactionsData(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const getDashboardCountAction = createAsyncThunk(
  "getDashboardCount",

  async (payload: any) => {
    try {
      const { data } = await server.adminDashboard.getDashboardSessionsData(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const getMonthlyDataAction = createAsyncThunk(
  "getMonthlyCount",

  async (payload: any) => {
    try {
      const { data } = await server.adminDashboard.getMonthlyData(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const getMasterDataset = createAsyncThunk(
  "getMasterDataset",

  async () => {
    try {
      const { data } = await server.adminDashboard.getMasterDataset();
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);
